import { configureStore } from '@reduxjs/toolkit';
import rolesReducer from './role/rolesSlice';
import permissionReducer from './permission/permissionSlice';
import usersReducer from './users/usersSlice';
import divisionReducer from './division/divisionSlice';
import businessUnitReducer from './businessUnit/businessUnitSlice';
import tagsReducer from './tags/tagsSlice';
import categoriesReducer from './categories/categoriesSlice';
import tasksReducer from './tasks/tasksSlice';
import auditsReducer from './audits/auditsSlice';
import locationsReducer from './locations/locationsSlice';
import schedulesReducer from './schedules/schedulesSlice';
import templatesReducer from './templates/templatesSlice';
import questionReducer from './question/questionSlice';
import mediaReducer from './media/mediaSlice';
import userPreferencesReducer from './userPreferences/userPreferencesSlice';
import questionResponsesReducer from './questionResponses/questionResponsesSlice';

export const store = configureStore({
  reducer: {
    roles: rolesReducer,
    permissions: permissionReducer,
    users: usersReducer,
    divisions: divisionReducer,
    businessUnits: businessUnitReducer,
    categories: categoriesReducer,
    tags: tagsReducer,
    tasks: tasksReducer,
    audits: auditsReducer,
    locations: locationsReducer,
    templates: templatesReducer,
    schedules: schedulesReducer,
    question: questionReducer,
    media: mediaReducer,
    userPreferences: userPreferencesReducer,
    questionResponses: questionResponsesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
